export default {
    navigationBarTitleText: "项目详情",
  };
  